<ion-header class="ion-no-border ion-no-padding">
  <ion-grid class="ion-no-padding ion-align-items-center header-grid">
    <ion-row class="ion-justify-content-between ion-align-items-center header-row">
      <ion-col size="auto">
        <ion-title color="dark" class="ion-no-padding header-1">
          {{ 'nps.header_title' | translate }}
        </ion-title>
      </ion-col>

      <ion-col size="auto" *ngIf="!view().isSelectionMade && feedbackQuestion.answer_type === 'Emoji'">
        <ion-text color="dark">
          {{ timerValue$ | async }}
        </ion-text>
      </ion-col>
    </ion-row>

    <ion-row class="ion-align-items-center header-row">
      <ion-col>
        <ion-title color="dark" class="ion-no-padding header-2">
          {{ feedbackQuestion.question || ('nps.header_2' | translate) }}
        </ion-title>
      </ion-col>
    </ion-row>
  </ion-grid>
</ion-header>

<ng-container [ngSwitch]="feedbackQuestion.answer_type">
  <monorepo-nps-emoji-feedback
    *ngSwitchCase="'Emoji'"
    [feedbackQuestion]="feedbackQuestion"
    (selectionMade)="onSelectionMade()"
    (feedbackChange)="onFeedbackChange($event)"
  ></monorepo-nps-emoji-feedback>
</ng-container>

<ion-footer class="ion-no-border">
  <ion-button
    expand="block"
    class="ion-margin-vertical ion-text-capitalize"
    [disabled]="!view().enableSubmit || !view().userFeedback?.answer"
    (click)="submitFeedback()"
  >
    {{ 'nps.submit' | translate }}
  </ion-button>

  <ion-button expand="block" class="ion-text-capitalize" color="light" (click)="skipFeedback()">
    {{ 'nps.skip' | translate }}
  </ion-button>
</ion-footer>
